export default {
  // 數據統計
  totalData: "共計{count}條數據",

  // 加載
  loading: "拼命加載中",

  // 表格列
  operation: "操作",
  client: "客戶端",
  state: "狀態",
  updateTime: "更新時間",
  paymentMethod: "收款方式",
  paymentDetail: "收款詳情",
  bankCard: "銀行卡號/賬號",
  bankBranch: "銀行支行",
  bankName: "銀行名稱",

  // 空狀態
  noPaymentData: "當前調證文件中未解析到收款方式記錄數據",

  // 下載
  downloadDetails: "下載數據明細",
  downloadFileName: "數據明細",
};
